import { createFileRoute } from '@tanstack/react-router'
import { TeamProgressPage } from '@/features/learn/team-page'

export const Route = createFileRoute('/_authenticated/learn/team')({
  staticData: { title: 'Team progress' },
  component: TeamProgressPage,
})
